import React from 'react';
import { useState, useEffect } from 'react';
import './css/Header.css';
import discordIcon from './image/TweakBotLogo.png';

const Header = ({ mobileMenuOpen, setMobileMenuOpen }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <div className="logo">
          <img src={discordIcon} alt="Discord Bot Logo" className="logo-image" />
          <span className="logo-text">TweakBot</span>
        </div>
        
        <button 
          className={`mobile-menu-button ${mobileMenuOpen ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`navigation ${mobileMenuOpen ? 'active' : ''}`}>
          <a href="#commands" onClick={() => setMobileMenuOpen(false)}>Команды</a>
          <a href="https://discord.gg/CaxKBEkMtp" onClick={() => setMobileMenuOpen(false)}>Discord сервер</a>
          <a href="https://discord.com/oauth2/authorize?client_id=1009421126776127548">
            <button className="add-to-discord">Добавить в Discord</button>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;